const UsersQuery = () => (
	[
		{
			status: 'Scientist - creative mind - crypto enthusiast - photographer',
			icon: 'url',
			username: 'Brian Dawson',
			url: '',
		},
		{
			status: 'Scientist - creative mind - crypto enthusiast - photographer',
			icon: 'url',
			username: 'Brian Dawson',
			url: '',
		},
		{
			status: 'Scientist - creative mind - crypto enthusiast - photographer',
			icon: 'url',
			username: 'Brian Dawson',
			url: '',
		},
		{
			status: 'Scientist - creative mind - crypto enthusiast - photographer',
			icon: 'url',
			username: 'Brian Dawson',
			url: '',
		},
		{
			status: 'Scientist - creative mind - crypto enthusiast - photographer',
			icon: 'url',
			username: 'Brian Dawson',
			url: '',
		},
		{
			status: 'Scientist - creative mind - crypto enthusiast - photographer',
			icon: 'url',
			username: 'Brian Dawson',
			url: '',
		},
		{
			status: 'Scientist - creative mind - crypto enthusiast - photographer',
			icon: 'url',
			username: 'Brian Dawson',
			url: '',
		},
		{
			status: 'Scientist - creative mind - crypto enthusiast - photographer',
			icon: 'url',
			username: 'Brian Dawson',
			url: '',
		},
		{
			status: 'Scientist - creative mind - crypto enthusiast - photographer',
			icon: 'url',
			username: 'Brian Dawson',
			url: '',
		},
		{
			status: 'Scientist - creative mind - crypto enthusiast - photographer',
			icon: 'url',
			username: 'Brian Dawson',
			url: '',
		},
		{
			status: 'Scientist - creative mind - crypto enthusiast - photographer',
			icon: 'url',
			username: 'Brian Dawson',
			url: '',
		},
		{
			status: 'Scientist - creative mind - crypto enthusiast - photographer',
			icon: 'url',
			username: 'Brian Dawson',
			url: '',
		},
		{
			status: 'Scientist - creative mind - crypto enthusiast - photographer',
			icon: 'url',
			username: 'Brian Dawson',
			url: '',
		},
	]
)

export default UsersQuery



// WEBPACK FOOTER //
// ./src/query/users.js